import { Box, Tooltip, Badge, styled, useTheme } from '@mui/material';
import React from 'react';
import { Link } from 'react-router-dom';

const LogoWrapper = styled(Link)(
  ({ theme }) => `
        color: ${theme.colors.alpha.trueWhite[100]};
        padding: ${theme.spacing(0, 1, 0, 0)};
        display: flex;
        align-items: center; // Center items vertically
        text-decoration: none;
        font-weight: ${theme.typography.fontWeightBold};
`
);

const LogoSignWrapper = styled(Box)(
  ({ theme }) => `
        display: flex;
        align-items: center; // Ensure logo and text are aligned
        transition: ${theme.transitions.create(['transform'])};
        &:hover {
        transform: scale(1.1); // Slight scale on hover
        }
`
);

const StyledText = styled('div')(
  ({ theme }) => `
      
        font-size: 20px;
        margin-left:  -10px; // Adjust according to your needs
        color: ${theme.colors.alpha.trueWhite[100]};
`
);
interface LogoProps {
  url?: string;
}
function Logo({ url = "/" }: LogoProps) {
  const theme = useTheme();

  return (
    <LogoWrapper to={'/'}>
          <LogoSignWrapper>
              <img
                  style={{ height: 70, width: 70 }}
                  src="/static/images/logo/logo3.png"
                  alt="Logo Image"
              />
             
          </LogoSignWrapper>
          <StyledText>vangard</StyledText>
    </LogoWrapper>
  );
}

export default Logo;
